import { Ajax } from '../ajax/Ajax';
import { Auth } from '../auth/Auth';
import { SDK } from '../index';
import { IDoryConfig } from '../interface/IDoryConfig';

//#region Interfaces
export type IRestResponse = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
};
export type IRestRequest = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};
//#endregion

/**
 * This service offers functions for all CRUD operations. It makes sure that a valid token is present before every request.
 *
 * This is a basic service to access the Dory-Middleware and it is used from many other services like InstrumentInfo, News, Timeseries.
 */
export class Rest extends Ajax {
  /**
   * @hidden
   */
  static install(instance: SDK) {
    instance['_rest'] = new Rest(instance.config, instance.Auth);
  }

  private config: IDoryConfig;
  /**
   * @hidden
   */
  constructor(config: IDoryConfig, serviceAuth: Auth) {
    super(config.rest);
    this.auth = serviceAuth;

    this.config = config;
  }

  /**
   * Set rest endpoint
   *
   * @param newEndpoint  full url to new endpoint
   */
  public setUrlEndpoint(newEndpoint: string): void {
    this.config.rest.url = newEndpoint;
  }
  /**
   * Get rest endpoint
   */
  public getUrlEndpoint(): string {
    return this.config.rest.url;
  }
}
